import React, { ReactElement, SyntheticEvent } from "react";
import Select from "react-select";

type Option = {
  label: string;
  value: string;
};

interface StyledSelectProps {
  options: Option[];
  defaultOptions: Option[];
  handleChange: (selectedOptions: Option[] | Option, action: object) => void;
  handleInputChange: (selectedValue: string, action: object) => void;
  handleBlur: (event: SyntheticEvent<HTMLElement>) => void;
  name: string;
  isMulti: boolean;
  selectedOptions: Option[];
  isClearable: boolean;
  disabled: boolean;
  styles: {};
}

const StyledSelect = ({
  options,
  defaultOptions,
  handleChange,
  handleInputChange,
  name,
  isMulti,
  selectedOptions,
  handleBlur,
  isClearable,
  disabled,
  styles,
}: StyledSelectProps): ReactElement => {
  return (
    <>
      <Select
        closeMenuOnSelect={false}
        isMulti={isMulti}
        options={options}
        defaultOptions={defaultOptions}
        onChange={handleChange}
        onInputChange={handleInputChange}
        onBlur={handleBlur}
        name={name}
        value={
          selectedOptions && selectedOptions.length
            ? selectedOptions
            : defaultOptions
        }
        maxMenuHeight={120}
        minMenuHeight={100}
        isClearable={isClearable}
        isDisabled={disabled}
        styles={styles}
      />
    </>
  );
};

export default StyledSelect;
